import { FC } from 'react'
import { Typography } from '@mui/material'
import { DropzoneRootProps, FileWithPath } from 'react-dropzone'
import FileUploadArea from '../../../../../components/File/FileUpload'
import FileViewRow from '../../../../../components/File/FileViewRow'
import { StyledCard, StyledCardContent, StyledCardHeader } from './styledComponents'

interface Props {
  jobFile: File | null
  existingJobFile: any
  setExistingJobFile: (val: any) => void
  jobAdLink: string
  getRootProps: <T extends DropzoneRootProps>(props?: T) => T
  getInputProps: <T extends DropzoneRootProps>(props?: T) => T
  acceptedFiles: readonly FileWithPath[]
  isDragActive: boolean
  deleteJobFileHandler: (id: string) => Promise<void>
}

const JobFileSection: FC<Props> = ({
  jobFile,
  existingJobFile,
  setExistingJobFile,
  jobAdLink,
  getRootProps,
  getInputProps,
  acceptedFiles,
  isDragActive,
  deleteJobFileHandler,
}) => {
  return (
    <StyledCard>
      <StyledCardHeader title="Job File (PDF or Word)" />
      <StyledCardContent>
        {!existingJobFile && !jobFile && !jobAdLink && (
          <Typography variant="body2" color="error" sx={{ mb: 2 }}>
            * Job File or Job Ad Link is required
          </Typography>
        )}
        <FileUploadArea
          getRootProps={getRootProps}
          getInputProps={getInputProps}
          acceptedFiles={acceptedFiles}
          isDragActive={isDragActive}
          title="Job File"
          supportedFormats={['PDF', 'DOC', 'DOCX']}
        />
        {existingJobFile && (
          <FileViewRow
            fileName={existingJobFile.name || 'Job File'}
            fileSource={existingJobFile.file?.url}
            hasPreview={false}
            onRemove={async () => {
              if (existingJobFile.id) {
                await deleteJobFileHandler(existingJobFile.id)
              }
              setExistingJobFile(null)
            }}
          />
        )}
      </StyledCardContent>
    </StyledCard>
  )
}

export default JobFileSection
